export default __webpack_public_path__ + "static/mdvorak-944fe394012957c4432116ae708c773d.jpeg";